define('gameday-index-gdtracking/src/OmnitureGamedayPage',['require','exports','module','jquery','tracking/omniture'],function(require,exports,module){
    var $ = require('jquery'),
        OmnitureFactory = require( "tracking/omniture" ),
        Omniture = OmnitureFactory.Omniture;

    function OmnitureGamedayPage(props){
        Omniture.call(this,props);
        
        this.addEvents('event4');
    }

    OmnitureFactory.create(OmnitureGamedayPage);

    return OmnitureGamedayPage
}); 
